export enum QuoteType {
  PreTrip = 'PRETRIP',
  SingleTrip = 'SINGLETRIP',
  MultiTrip = 'MULTITRIP',
}
